<template>
  <div class="article-list">
    <div>
      <!-- 标题0  摘要1 列表2 -->
      <div
        v-for="(item, index) in articleListData"
        :key="index"
        style="margin: 12px 0"
      >
        <div
          class="article-list-item"
          :class="active == index ? 'curActive' : ''"
        >
          <div>
            <h4>
              <div @click="openDetails(item.articlesequenceid, item, index)">{{ handleTitle(item.title) }}</div>
            </h4>
            <p v-if="showModel == 1">
              {{ item.markinfo }}
            </p>
            <div class="info">
              <span>
                <span>
                  <em class="tag1" v-if="item.viocesize >= 1 && item.viocesize <= 9"> 原创 </em>
                  <em class="tag2" v-else>转载</em></span>
                  {{ item.paperName || item.papername }}{{ item.updatetime | handleTime }}
              </span>
              <span
                class="more"
              >
                <img
                  v-if="!item.isHasSimilar"
                  @click="ViewSimilar(item, index)"
                  :src="item.isClick ? iconUrl1 : iconUrl"
                  title="查看相似文章"
                />
              </span>
            </div>
          </div>
        </div>
        <ul class="end-half" :id="item.articlesequenceid">
          <li class="son-number" v-if="item.Sublist">
            <img src="../../../../assets/jfrb/sameArticle.png" alt="" />
            <p v-if="item.Sublist">共{{ item.Sublist.length }}篇</p>
            <p v-else>共0篇</p>
          </li>
          <li
            class="son-li"
            v-for="(it, ind) in item.Sublist"
            :key="ind"
            :class="active == index && sameActive == ind ? 'curActive' : ''"
          >
            <div class="article-list-item">
              <div>
                <h4 @click="openDetailSame(it.articlesequenceid, it, ind, index)">
                  {{ handleTitle(it.title) }}
                </h4>
                <div class="info">
                  <span>
                    <span>
                      <em class="tag1" v-if="it.viocesize >= 1 && it.viocesize <= 9"> 原创 </em>
                      <em class="tag2" v-else>转载</em>
                    </span>
                    {{ it.paperName || it.papername }} &nbsp;{{ it.updatetime | handleTime }}
                  </span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from "@/pages/EventBus.js";
// import "../../../styles/fanwenicon.css";
import { GetSameArticles } from "@/api/index.js";

export default {
  props: [
    "channelId",
    "showModel",
    "showWorksDel",
    "articleListData",
    "showStatus",
    "tabWordsource",
    "searchCondition",
    "isCheckbox",
    "industryTypeId",
    "textPane",
    "isSource",
    "biIconType",
    "propagate"
  ],

  data() {
    return {
      selectedItems: [],
      active: null,
      // articleListData: [
        // {
        //   title:
        //     "外交部：中方愿与太平洋岛国继续密切沟通，帮助岛国更好应对气候变化",
        //   auth: "潮新闻客户端 2023-05-06 18:02:32",
        // },
      // ],
      sameActive: null,
      iconUrl: require("../../../../assets/jfrb/more.png"),
      iconUrl1: require("../../../../assets/jfrb/more1.png"),
      msg: "查看相似文章",
      dataList: [],
      lineOnes: [],
      lineThrees: []
    };
  },
  activated() {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    openDetails(articlesequenceid, item, index) {
      this.InfoDialog = false;
      eventBus.$emit("changeInfoStatus", false);
      this.$emit("openDetails", false, articlesequenceid, item);
      this.active = index;
      eventBus.$emit("curListIndex", index); // 记录当前index
    },
    // 处理标题字段为空时
    handleTitle(val) {
      if (val) {
        return val;
      } else {
        let val = "无标题";
        return val;
      }
    },
    //处理关键词
    handleKeyword(str) {
      var result = str.split(",");
      result = result.slice(0, 3);
      let newStr = result.join(" ");
      return newStr;
    },
    //查看相似文章
    ViewSimilar(item, index) {
      let that = this;
      let obj = that.articleListData[index];
      obj.showDetail = !obj.showDetail;
      var nid = obj.articlesequenceid;
      var pdom = document.getElementById(nid);
      if (obj.hasOwnProperty("Sublist") != true) {
        let params = {
          ...this.searchCondition,
          industryTypeId: this.industryTypeId ? this.industryTypeId : '0',
          sameTag: { sameid: item.same_id, sametype: 2 },
        };
        GetSameArticles(params)
          .then((res) => {
            // console.log(res);
            let Sublist = res.data.rows;
            that.$set(obj, "Sublist", Sublist);
            that.$nextTick(() => {
              if (Sublist.length > 0) {
                setTimeout(function () {
                  if (obj.showDetail) {
                    pdom.style.height = pdom.scrollHeight + "px";
                    obj.isClick = true;
                    // pdom.style.height = 300 + "px";
                  } else {
                    pdom.style.height = 0;
                    obj.isClick = false;
                  }
                }, 1);
              } else {
                pdom.innerHTML =
                  '<p style="padding:10px 0;text-align: center;font-size: 14px;font-weight: 400;color:var(--text-tips);">暂无相似文章</p>';
                setTimeout(function () {
                  if (obj.showDetail) {
                    pdom.style.height = pdom.scrollHeight + "px";
                    obj.isClick = true;
                    // pdom.style.height = 300 + "px";
                  } else {
                    pdom.style.height = 0;
                    obj.isClick = false;
                  }
                }, 1);
              }
            });
          })
          .catch((err) => {
            console.warn(err);
          });
      }
      setTimeout(function () {
        if (obj.showDetail) {
          pdom.style.height = pdom.scrollHeight + "px";
          obj.isClick = true;
          // pdom.style.height = 300 + "px";
        } else {
          pdom.style.height = 0;
          obj.isClick = false;
        }
      }, 1);
    },
    //相似文章查看详情
    openDetailSame(articlesequenceid, item, ind, index) {
      this.InfoDialog = false;
      eventBus.$emit("changeInfoStatus", false);
      this.$emit("openDetails", false, articlesequenceid, item);
      this.active = index;
      eventBus.$emit("curListIndex", index); // 记录当前index
      this.sameActive = ind;
    },
  },
};
</script>

<style lang="scss" scoped>
.article-list {
}
.article-list-item {
  display: flex;
  justify-content: space-between;
  // margin: 12px 0;
  padding: 8px;
  .attribute {
    // display: flex;
    // align-items: center;
    font-size: 12px;
    .keyword {
      span {
        font-size: 12px;
        color: var(--text-1);
      }
    }
    .heat {
      display: flex;
      align-items: center;
      font-weight: 400;
      color: var(--error-color);
      // margin-left: 10px;
      span {
        font-weight: 400;
        font-size: 12px;
        color: var(--error-color);
      }
    }
  }
  .info {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    flex: 1;
    margin-top: 8px;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .version-history {
      display: none;
      // margin-right: 15px;
      &:hover {
        color: var(--text-link);
      }
    }
    .del {
      display: block;
      &:hover {
        color: var(--text-link);
      }
    }
    .more {
      img {
        width: 18px;
        height: 18px;
      }
    }
    em {
      font-style: normal;
      font-size: 12px;
      height: 20px;
      line-height: 18px;
      padding: 0 6px;
      // margin-top: 2px;
      float: left;
      border-radius: 2px;
      margin-right: 5px;
    }
    .tag1 {
      color: #4f8e4b;
      background: #f6fff2;
    }
    .tag2 {
      color: #3b77a5;
      background: #edf5fc;
    }
  }
  div:first-child {
    margin-right: 15px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex: 1;
  }
  h4 {
    font-weight: normal;
    font-weight: 400;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    // line-clamp: 2;
    display: -webkit-box;
    cursor: pointer;
    color: var(--text-1);
    margin-bottom: 5px;
  }
  p {
    font-size: 12px;
    color: var(--text-3);
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    display: -webkit-box;
    margin: 2px 0 6px;
  }
  span {
    font-size: 12px;
    color: var(--text-tips);
  }
  .img {
    width: 80px;
    height: 80px;
    display: block;
    overflow: hidden;
    border-radius: 4px;
    background: var(--bg);
    img {
      width: 100%;
      height: 100%;
      transform: scale(1);
      transition: transform 0.2s ease-in-out;
    }
  }
  &:hover {
    cursor: pointer;
    h4 {
      color: var(--brand);
    }
    .img {
      img {
        transform: scale(1.1);
      }
    }
    .del {
      display: block;
    }
    .version-history {
      display: block;
    }
  }
}
.curActive {
  background: rgba(233, 241, 246, 0.75);
  h4 {
    color: #222;
  }
}
.end-half, .end-half-clue {
  box-sizing: border-box;
  height: 0;
  transition: height 0.5s;
  overflow: hidden;
  background: #f5f9f8;
  border-radius: 2px;
  padding: 0 15px;
  .son-number {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px 0px 10px;
    img {
      width: 102px;
      height: 20px;
    }
    p {
      font-size: 12px;
      font-weight: 400px;
      color: rgba(32, 45, 64, 0.45);
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}
.report {
  margin-right: 8px;
  cursor: pointer;
  i {
    margin-right: 3px;
  }
}
.report:hover {
  color: var(--text-link);
}

.clue img {
  width: 14px;
  height: 14px;
}
.clue-title {
  position: relative;
}
.clue-title i{
  position: absolute;
  width: 102px;
  left: 25px;
  color: #fff;
  font-size: 12px;
  top: 1px;
  font-style: normal;
}

</style>
